<template>
  <el-dialog title="蓝牙配置"
             :visible.sync="showModal"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-row>
      <el-form :model="blueInfo"
               :rules="blueRules"
               ref="blueForm"
               label-width="180px"
               class="blue-form">

        <el-form-item label="MAC地址："
                      prop="mac">
          <el-input v-model.trim="blueInfo.mac"
                    placeholder="6字节十六进制（0~9，a~f, A~F）"></el-input>
        </el-form-item>

        <el-form-item label="广播时间间隔(ms)："
                      prop="bdInterval">
          <el-select v-model="blueInfo.bdInterval"
                     placeholder="请选择">
            <el-option v-for="item in listBroadCast"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="配对码："
                      prop="pairCode">
          <el-input-number class="price-input"
                           v-model="blueInfo.pairCode"
                           :min="0"
                           :max="99999999"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>

        <el-form-item label="发射功率(dBm)："
                      prop="radioPower">
          <el-select v-model="blueInfo.radioPower"
                     placeholder="请选择">
            <el-option v-for="item in listRadioPower"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="连接间隔下限(ms)："
                      prop="connCIMin">
          <el-input-number class="price-input"
                           v-model="blueInfo.connCIMin"
                           :min="8"
                           :max="4000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>

        <el-form-item label="连接间隔上限(ms)："
                      prop="connCIMax">
          <el-input-number class="price-input"
                           v-model="blueInfo.connCIMax"
                           :min="8"
                           :max="4000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>

        <el-form-item label="从机潜伏次数："
                      prop="connLatency">
          <el-input-number class="price-input"
                           v-model="blueInfo.connLatency"
                           :min="0"
                           :max="499"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>

        <el-form-item label="连接丢失超时时间(ms)："
                      prop="connTimeOut">
          <el-input-number class="price-input"
                           v-model="blueInfo.connTimeOut"
                           :min="100"
                           :max="32000"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>

        <el-form-item label="自动更新延时(x100ms)："
                      prop="connDelay">
          <el-input-number class="price-input"
                           v-model="blueInfo.connDelay"
                           :min="0"
                           :max="100"
                           :step="1"
                           :controls="false"
                           step-strictly></el-input-number>
        </el-form-item>

        <el-form-item label="广播数据："
                      prop="bdData">
          <el-input v-model.trim="blueInfo.bdData"
                    placeholder="28字节ASCII码字符串"></el-input>
        </el-form-item>

        <el-form-item label="接收通道UUID："
                      prop="uuidRecv">
          <el-input v-model.trim="blueInfo.uuidRecv"
                    placeholder="2字节十六进制UUID（0~9，a~f, A~F）"></el-input>
        </el-form-item>

        <el-form-item label="发送通道UUID："
                      prop="uuidSend">
          <el-input v-model.trim="blueInfo.uuidSend"
                    placeholder="2字节十六进制UUID（0~9，a~f, A~F）"></el-input>
        </el-form-item>

      </el-form>
    </el-row>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/lock/setBlue'"
                 type="primary"
                 @click="handleConfirm('blueForm')">
        写 入
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      blueInfo: {
        name: '', //                   16字节
        mac: '', //MAC地址             12字节
        bdInterval: '', //广播时间间隔  100、200、500、1000、2000、5000
        pairCode: '', //配对码         8字节数字
        radioPower: '', //发射功率
        connCIMin: '', //连接间隔下限     范围[8-4000]毫秒
        connCIMax: '', //连接间隔上限     范围[8-4000]毫秒
        connLatency: '', //从机潜伏次数    范围[0-499]次
        connTimeOut: '', //连接丢失超时时间  范围[100-32000]毫秒
        connDelay: '', //自动更新延时       范围[0-100]*100毫秒
        bdData: '', //广播数据            28字节
        uuidRecv: '', //接收通道UUID    4字节Hex字符串
        uuidSend: '' //发送通道UUID     4字节Hex字符串
      },
      blueRules: {
        mac: [{ required: true, message: '6字节十六进制' }],
        pairCode: [{ required: true, message: '8位整数数字' }],
        connCIMin: [{ required: true, message: '范围[8-4000]' }],
        connCIMax: [{ required: true, message: '范围[8-4000]' }],
        connLatency: [{ required: true, message: '范围[0-499]' }],
        connTimeOut: [{ required: true, message: '范围[100-32000]' }],
        connDelay: [{ required: true, message: '范围[0-100]' }],
        bdData: [{ required: true, message: '28字节ASCII码' }],
        uuidRecv: [{ required: true, message: '2字节十六进制' }],
        uuidSend: [{ required: true, message: '2字节十六进制' }]
      },
      listBroadCast: ['100', '200', '500', '1000', '2000', '5000'],
      listRadioPower: [
        '-40dBm',
        '-20dBm',
        '-16dBm',
        '-12dBm',
        '-8dBm',
        '-4dBm',
        '0dBm',
        '3dBm',
        '4dBm'
      ]
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getLockBlue({ sn: this.data.sn }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.blueInfo = data.blue
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch
            .setLockBlue({
              ...this.blueInfo,
              //...this.channelInfo,
              id: this.data.id,
              sn: this.data.sn
            })
            .then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.$emit('handleClose')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
